import {  put, call, all, fork, takeLatest } from 'redux-saga/effects';
import {LoginActionConst, LoginResultConst,LoginActionByTokenConst, LoginActionByTokenResultConst, UserActionCaravanserailOpenConst, UserActionCaravanserailOpenConstResult} from "../consts"
import Cookies from 'js-cookie';
import {checkLogin, get_caravanserail_user_list} from "../services"


function* checkLoginSaga(action) {
    
    const result = yield call(checkLogin, action.email, action.password)
    
    yield put({ type: LoginResultConst, navigation: action.navigation, user: result.user});
}

function* checkLoginByTokenSaga(action) {
    
    const result = yield call(checkLogin, action.email, action.password)
    
    yield put({ type: LoginActionByTokenResultConst, navigation: action.navigation, user: result.user});
}

function* getCaravanserailsUser(action) {

    try{ 
        const user = JSON.parse(Cookies.get("user"))

        console.log("saga.getCaravanserailsUser", user)
        if(action.action === "open"){
            const result = yield call(get_caravanserail_user_list, user.id)
            yield put({ type: UserActionCaravanserailOpenConstResult, caravanserails: result.caravanserails});
        }
    }
    catch(e){
        
    }
}

function* actionWatcher() {
    
    yield takeLatest(LoginActionByTokenConst, checkLoginByTokenSaga)
    yield takeLatest(LoginActionConst, checkLoginSaga)
    yield takeLatest(UserActionCaravanserailOpenConst, getCaravanserailsUser)
}

export default function* rootSaga() {
    yield all([
        fork(actionWatcher)
    ]);
 }